import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CircularProgress, Paper } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { downloadCredencialArt } from "../../../redux/actions/certificadoCobertura";
import { base64ToUint8Array, downloadFile } from "../../../util/files";
import HeaderForm from "../../commons/labels/HeaderForm";
import { StyledNominaContainer } from "../../styled/Personal";
import NominaTable from "../certificadoCobertura/nomina/NominaTable";

const CredencialArtContainer = () => {
    const dispatch = useDispatch();
    const [nominasSelected, setNominasSelected] = useState({});

    const descargarCredencialArt = useSelector(
        (state) => state.certificadoCobertura.descargarCredencialArt
    );

    const nominas = Object.keys(nominasSelected).map((idNomina) =>
        parseInt(idNomina, 10)
    );

    const getExtensionByMime = (mimeType) => {
        if (mimeType === "application/pdf") {
            return "pdf";
        }
        if (mimeType === "application/zip") {
            return "zip";
        }
        if (mimeType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            return "xlsx";
        }
        return "pdf";
    };

    const getBase64FromPayload = (payload) => {
        if (typeof payload === "string") {
            return payload;
        }

        if (!payload || typeof payload !== "object") {
            return "";
        }

        return (
            payload.base64 ||
            payload.archivo ||
            payload.file ||
            payload.data ||
            payload.contenido ||
            ""
        );
    };

    const handleDownloadCredenciales = () => {
        if (nominas.length === 0) {
            return;
        }

        dispatch(downloadCredencialArt({ nominas }))
            .then((response) => {
                const rawPayload = response?.value?.data;

                if (rawPayload instanceof Blob) {
                    downloadFile(rawPayload, "credenciales-art.pdf");
                    return;
                }

                const base64Payload = getBase64FromPayload(rawPayload);

                if (!base64Payload || typeof base64Payload !== "string") {
                    toast.error("No se pudo obtener el archivo de credenciales");
                    return;
                }

                const mimeType = base64Payload.startsWith("data:")
                    ? base64Payload.substring(5, base64Payload.indexOf(";"))
                    : "application/pdf";

                const bytes = base64ToUint8Array(base64Payload);
                const extension = getExtensionByMime(mimeType);
                downloadFile(bytes, `credenciales-art.${extension}`);
            })
            .catch(() => {
                toast.error("Error al descargar credenciales");
            });
    };

    return (
        <Paper>
            <HeaderForm title="Credencial ART" />
            <StyledNominaContainer.Container>
                <StyledNominaContainer.ContentContainer>
                    <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                        <NominaTable
                            nominasSelected={nominasSelected}
                            setNominasSelected={setNominasSelected}
                        />
                    </div>
                </StyledNominaContainer.ContentContainer>
                <StyledNominaContainer.ButtonContainer>
                    <StyledNominaContainer.Button
                        variant="contained"
                        color="primary"
                        endIcon={<FileDownloadIcon />}
                        onClick={handleDownloadCredenciales}
                        disabled={descargarCredencialArt.loading || nominas.length === 0}
                    >
                        {descargarCredencialArt.loading ? (
                            <CircularProgress size={24} thickness={4} color="secondary" />
                        ) : (
                            "Descargar credenciales"
                        )}
                    </StyledNominaContainer.Button>
                </StyledNominaContainer.ButtonContainer>
            </StyledNominaContainer.Container>
        </Paper>
    );
};

export default CredencialArtContainer;
